<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Puzzle-Root',
  data() {
    return {};
  },
};
</script>
